import { AnyAction } from 'redux';

import {
    CLEAR_GEO_LOCATION,
    PERMANENTLY_DISMISS_STICKY,
    UPDATE_ANY_LEAD_POPUP_SHOWN,
    UPDATE_CALL_SERVICE,
    UPDATE_COUNTY,
    UPDATE_FILTER,
    UPDATE_GEO_LOCATION,
    UPDATE_LEAD,
    UPDATE_MULTI_COUNTY_LIST,
    UPDATE_NTM_ACTIVE_STEP,
    UPDATE_NTM_VISITED,
    UPDATE_PRE_OEP_STATE_CONFIG,
    UPDATE_PHONE,
    UPDATE_PLAN_TYPE,
    UPDATE_TRACKING_PARAMS,
    UPDATE_TRACKING_STATUS,
    UPDATE_ZIP_AND_COUNTY,
    UPDATE_ZIP_MODAL_CTA,
    UPDATE_ZIP_MODAL_DESTINATION,
    UPDATE_ZIP_MODAL_HEADING,
    UPDATE_OEP_STATE_CONFIG,
    UPDATE_OEP_STATE_PERIOD,
} from '../Actions/GlobalActions';

import initialState from './GlobalInitialState';

const reducer = (state = initialState, action: AnyAction): typeof initialState => {
    switch (action.type) {
        case UPDATE_ANY_LEAD_POPUP_SHOWN:
            return {
                ...state,
                hasAnyLeadPopupShown: true,
            };
        case UPDATE_CALL_SERVICE:
            return {
                ...state,
                ...(action.payload as Record<string, string | boolean>),
            };
        case UPDATE_FILTER:
            return {
                ...state,
                filter: action.payload as string,
            };
        case UPDATE_LEAD:
            return {
                ...state,
                leadId: (action.payload as Record<string, string>).leadId,
                leadToken: (action.payload as Record<string, string>).leadToken,
            };
        case UPDATE_NTM_ACTIVE_STEP:
            return {
                ...state,
                ntmActiveStep: action.payload as typeof initialState.ntmActiveStep,
            };
        case UPDATE_NTM_VISITED:
            return {
                ...state,
                ntmVisited: [...state.ntmVisited, action.payload] as typeof initialState.ntmVisited,
            };
        case UPDATE_PRE_OEP_STATE_CONFIG:
            return {
                ...state,
                preOepStateConfig: action.payload as typeof initialState.preOepStateConfig,
            };
        case UPDATE_OEP_STATE_CONFIG:
            return {
                ...state,
                oepStateConfig: action.payload as typeof initialState.oepStateConfig,
            };
        case UPDATE_PHONE:
            return {
                ...state,
                phone: action.payload as typeof initialState.phone,
            };
        case UPDATE_PLAN_TYPE:
            return {
                ...state,
                planType: action.payload as typeof initialState.planType,
            };
        case UPDATE_TRACKING_PARAMS:
            return {
                ...state,
                trackingParams: {
                    ...state.trackingParams,
                    ...action.payload,
                } as typeof initialState.trackingParams,
            };
        case UPDATE_TRACKING_STATUS:
            return {
                ...state,
                trackingStatus: action.payload as typeof initialState.trackingStatus,
            };
        case UPDATE_COUNTY:
            return {
                ...state,
                geoLocation: {
                    zip: state.geoLocation.zip,
                    countyName: action.payload as string,
                },
            };
        case UPDATE_ZIP_AND_COUNTY:
            return {
                ...state,
                geoLocation: {
                    zip: (action.payload as GeoLocation).zip,
                    countyName: (action.payload as GeoLocation).countyName,
                },
            };
        case UPDATE_GEO_LOCATION:
            return {
                ...state,
                geoLocation: {
                    ...(action.payload as GeoLocation),
                    ssacd: (action.payload as GeoLocation).ssacd?.replace(/^0/, ''),
                },
            };
        case UPDATE_MULTI_COUNTY_LIST:
            return {
                ...state,
                multiCountyList: [...(action.payload as GeoLocation[])],
            };
        case PERMANENTLY_DISMISS_STICKY:
            return {
                ...state,
                hideDismissableStickyPermanently: true,
            };
        case CLEAR_GEO_LOCATION:
            return {
                ...state,
                geoLocation: { zip: '', countyName: '' },
            };
        case UPDATE_ZIP_MODAL_CTA:
            return {
                ...state,
                zipModalConfig: {
                    ...state.zipModalConfig,
                    customCta: action.payload as string,
                },
            };
        case UPDATE_ZIP_MODAL_DESTINATION:
            return {
                ...state,
                zipModalConfig: {
                    ...state.zipModalConfig,
                    customDestination: action.payload as string,
                },
            };
        case UPDATE_ZIP_MODAL_HEADING:
            return {
                ...state,
                zipModalConfig: {
                    ...state.zipModalConfig,
                    customHeading: action.payload as string,
                },
            };
        case UPDATE_OEP_STATE_PERIOD:
            return {
                ...state,
                oepStatePeriod: action.payload as typeof initialState.oepStatePeriod,
            };
        default:
            return state;
    }
};
export default reducer;
